import { HttpErrorResponse } from '@angular/common/http';
import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { IAgent, IAgentsResponse } from '../../shared/models/agents.model';

export const AGENTS_API_ACTIONS = createActionGroup({
  source: 'Agents API',
  events: {
    get: emptyProps(),
    update: props<IAgent>(),
    error: props<{ error: HttpErrorResponse }>(),
    getSuccess: props<IAgentsResponse>(),
    updateSuccess: props<IAgent>(),
  },
});
